// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"46":"BadgeTooltipV1","913":"BusinessProGuestLazyComponent"}[chunkId] + "." + {"46":"d01bff2a0e513a724ed4","913":"3e515c462e05f058cbfa"}[chunkId] + ".js";
};